import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section className="py-20 bg-accent overflow-hidden" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-218">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="w-full lg:w-1/2" data-id="element-219">
            <div className="relative rounded-[10px] overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-square" data-id="element-220">
              <img src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80" alt="Professional tow truck driver" className="w-full h-full object-cover" data-id="element-221" />
              <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply" data-id="element-222"></div>
            </div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-223">
            <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-6" data-id="element-224">
              Our Mission
            </span>
            <blockquote className="relative pl-6 border-l-4 border-primary" data-id="element-225">
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-secondary leading-tight md:leading-snug" data-id="element-226">
                "To keep our neighbors safe and moving, 24 hours a day, with
                professional care."
              </p>
            </blockquote>
            <div className="mt-8" data-id="element-227">
              <p className="text-gray-600 text-xl" data-id="element-228">
                We believe that roadside assistance shouldn't be a waiting game.
                Our zero-queue digital dispatch ensures help is routed to you
                the moment you need it.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}